import * as UIToolkit from '../../../UIToolkit/index';
import Utils from '../../../utils/util';
import FrontCubeData from '../../../frontCubeData/index';
import Config from '../../../config';

interface CommonData {
    direction: number
    rotate: number
    background: string,
    posWidth: number,
    imgMap: FreeObjMap,
    wareBoxedImgMap: FreeObjMap,
    boxSpec: string
}

interface Color {
    background: string,
    font: string
}

const singleGoodsDefaultWidth: number = Config.get({
    moduleName: 'goods',
    key: 'singleGoodsDefaultWidth'
});
const singleGoodsDefaultHeight: number = Config.get({
    moduleName: 'goods',
    key: 'singleGoodsDefaultHeight'
});

export interface GoodsRenderData extends CommonData {
    width: number,
    height: number,
    depth: number,
    col: number,
    row: number,
    lightColor?: Color
}

export interface SubGoodsRenderData {
    mainGoodsSize: PhysicsSize,

    // 商品方位
    direction: number,

    // 商品旋转角度
    rotate: number,
    posWidth: number,

    // 字码商品列表
    subSkuList: Array<SkuData>
}

// 组装商品渲染需要的数据
function mainGoods(cube: CubeNode): GoodsRenderData {
    let commonData: CommonData = makeCommonData(cube);
    let subSkuList: Array<SkuData> = FrontCubeData.getValue(cube.id, 'subSkuList');
    let color: Color = getGoodsColor(subSkuList[0]);

    let result: GoodsRenderData = {
        ...commonData,
        width: FrontCubeData.getNumberValue(cube.id, 'showWareWidth') || singleGoodsDefaultWidth, // 主商品展示宽度
        height: FrontCubeData.getNumberValue(cube.id, 'showWareHeight') || singleGoodsDefaultHeight, // 主商品展示高度
        depth: FrontCubeData.getNumberValue(cube.id, 'showWareDepth'), // 主商品展示深度
        col: FrontCubeData.getNumberValue(cube.id, 'surfaceWidth'),
        row: FrontCubeData.getNumberValue(cube.id, 'surfaceHeight'),
        lightColor: color
    };

    /**
     * 如果字码列表里存在商品，主商品的面宽和面高优先取字码列表的第一个商品，第一个商品就是主商品
     * 如果有字码，由于庞谦只更新了字码商品的数据，所以这里需要去字码列表里去取数据才准确
     */
    
    if (subSkuList.length > 1) {
        let mainSku: FreeObjMap = subSkuList[0];

        result.col = mainSku.surfaceWidth;
        result.row = mainSku.surfaceHeight;
    }

    return result;
}

// x轴叠放商品渲染数据组装
function xLineGoodsFolded(cube: CubeNode): GoodsRenderData {
    let commonData: CommonData = pileTypeMakeCommonData(cube,'x');
    let subSkuList: Array<SkuData> = FrontCubeData.getValue(cube.id, 'subSkuList');
    let color: Color = getGoodsColor(subSkuList[0]);

    let result: GoodsRenderData = {
        ...commonData,
        width: FrontCubeData.getNumberValue(cube.id, 'showXPileWareWidth') || singleGoodsDefaultWidth,
        height: FrontCubeData.getNumberValue(cube.id, 'showXPileWareHeight') || singleGoodsDefaultHeight,
        depth: FrontCubeData.getNumberValue(cube.id, 'showXPileWareDepth'),
        col: FrontCubeData.getNumberValue(cube.id, 'xPileSurfaceWidth'),
        row: FrontCubeData.getNumberValue(cube.id, 'xPileSurfaceHeight'),
        lightColor: color
    };

    return result;
}

// y轴叠放商品渲染数据组装
function yLineGoodsFolded(cube: CubeNode): GoodsRenderData {
    let commonData: CommonData = pileTypeMakeCommonData(cube,'y');
    let subSkuList: Array<SkuData> = FrontCubeData.getValue(cube.id, 'subSkuList');
    let color: Color = getGoodsColor(subSkuList[0]);

    let result: GoodsRenderData = {
        ...commonData,
        width: FrontCubeData.getNumberValue(cube.id, 'showYPileWareWidth') || singleGoodsDefaultWidth,
        height: FrontCubeData.getNumberValue(cube.id, 'showYPileWareHeight') || singleGoodsDefaultHeight,
        depth: FrontCubeData.getNumberValue(cube.id, 'showYPileWareDepth'),
        col: FrontCubeData.getNumberValue(cube.id, 'yPileSurfaceWidth'),
        row: FrontCubeData.getNumberValue(cube.id, 'yPileSurfaceHeight'),
        lightColor: color
    };

    return result;
}

function makeCommonData(cube: CubeNode): CommonData {
    // 方位#旋转角度
    let posDirection: string = FrontCubeData.getValue(cube.id, 'posDirection');
    let directionAndRotate: Array<string> = posDirection.split('#');
    let direction: number = Utils.toNumber(directionAndRotate[0] || 1);
    let rotate: number = Utils.toNumber(directionAndRotate[1] || 0);
    let wareOperType: number = FrontCubeData.getValue(cube.id, 'wareOperType');
    let backColor: string = FrontCubeData.getValue(cube.id, 'backColor');
    let background: string = wareOperType == 0 ? 'red' : (backColor || "#FFF");

    return {
        direction,
        rotate,
        background,
        posWidth: FrontCubeData.getNumberValue(cube.id, 'posWidth'),
        imgMap: FrontCubeData.getValue(cube.id, 'wareImgMap') || {},
        wareBoxedImgMap: FrontCubeData.getValue(cube.id, 'wareBoxedImgMap') || {},
        boxSpec: FrontCubeData.getValue(cube.id, 'boxSpec') || '',
    }
}

// 获取叠盖方位
function pileTypeMakeCommonData(cube: CubeNode,pileType:String): CommonData {
    // 方位#旋转角度
    let posDirection: string = ""
    if(pileType == 'x'){
        posDirection = FrontCubeData.getValue(cube.id, 'xpilePos');
    }else if(pileType == 'y'){
        posDirection = FrontCubeData.getValue(cube.id, 'ypilePos');
    }
    let directionAndRotate: Array<string> = posDirection.split('#');
    let direction: number = Utils.toNumber(directionAndRotate[0] || 1);
    let rotate: number = Utils.toNumber(directionAndRotate[1] || 0);
    let wareOperType: number = FrontCubeData.getValue(cube.id, 'wareOperType');
    let backColor: string = FrontCubeData.getValue(cube.id, 'backColor');
    let background: string = wareOperType == 0 ? 'red' : (backColor || "#FFF");

    return {
        direction,
        rotate,
        background,
        posWidth: FrontCubeData.getNumberValue(cube.id, 'posWidth'),
        imgMap: FrontCubeData.getValue(cube.id, 'wareImgMap') || {},
        wareBoxedImgMap: FrontCubeData.getValue(cube.id, 'wareBoxedImgMap') || {},
        boxSpec: FrontCubeData.getValue(cube.id, 'boxSpec') || '',
    }
}

// 字码渲染数据构造
function subGoods(cube: CubeNode): SubGoodsRenderData {
    let subSkuSrcList: Array<SkuData> = FrontCubeData.getValue(cube.id, 'subSkuList');
    let subSkuList: Array<SkuData> = getGoodsRenderData(subSkuSrcList);
    let posWidth: number = FrontCubeData.getNumberValue(cube.id, 'posWidth');
    let posDirection: string = FrontCubeData.getValue(cube.id, 'posDirection');
    let directionAndRotate: Array<string> = posDirection.split('#');
    let direction: number = Utils.toNumber(directionAndRotate[0] || 1);
    let rotate: number = Utils.toNumber(directionAndRotate[1] || 0);
    let mainGoodsSize: PhysicsSize = UIToolkit.centerGoodsSizeOneSurface(cube.id);

    return {
        direction,
        rotate,
        posWidth,
        subSkuList,
        mainGoodsSize
    }
}

function getGoodsRenderData(subSkuList: Array<FreeObjMap>): Array<SkuData> {
    let result: Array<SkuData> = subSkuList.map((sku) => {
        return {
            depth: sku.depth,
            height: sku.height,
            imgUri: sku.imgUri,
            itemNum: sku.itemNum,
            mainWareFlag: sku.mainWareFlag,
            realDepth: sku.realDepth,
            realHeight: sku.realHeight,
            realWidth: sku.realWidth,
            rfId: sku.rfId,
            shelfWareStatus: sku.shelfWareStatus,
            skuId: sku.skuId,
            surfaceDepth: sku.surfaceDepth,
            surfaceHeight: sku.surfaceHeight,
            surfaceWidth: sku.surfaceWidth,
            title: sku.title,
            wareImgMap: sku.wareImgMap,
            width: sku.width,
            backColor: sku.backColor ? sku.backColor : 'transparent'
        }
    });

    return result;
}

// 色值计算
function getGoodsColor(sku: SkuData): Color {
    // 对应渲染的品牌数据库
    let brandData: FreeObjMap|null = Config.getGlobalConfig('BRAND_DATA') || null;

    // 对应渲染的品牌数据库
    let benderBrandAndEnum: FreeObjMap|null = Config.getGlobalConfig('RENDER_BRAND_ENUM') || null;
    let result: Color = {
        background: '#fff',
        font: '#000'
    };

    if (brandData[sku.skuId] && benderBrandAndEnum[brandData[sku.skuId]]) {
        result.background = benderBrandAndEnum[brandData[sku.skuId]].color;
        result.font = benderBrandAndEnum[brandData[sku.skuId]].fontColor;
    }

    return result;
}

export default {
    mainGoods,
    xLineGoodsFolded,
    yLineGoodsFolded,
    subGoods
}
